<template>
        <div id="app">
          <div class="login-page forgot" v-if="isLoadingFunc">
            <router-view></router-view>
          </div>
        </div>
      </template>
      <script>
        export default {
          mounted() {
            //  to void ui glitchs or previous layout etc.
            this.isLoading = true;
          },
          data() {
            return {
              isLoading: false,
            }
          },
          methods: {},
          computed: {
            isLoadingFunc: function () {
              let token = this.$store.getters['auth/getToken'];
              if (!token) return this.isLoading;
            }
          }
        }
      </script>


// WEBPACK FOOTER //
// src/layouts/ForgotPassword.vue